import type { Component, OtpFormType } from './types';

import { OtpInput } from '@sgcmpteltd/uikit-react';

import { FormControl } from '../form-control';

const OtpFormControl = FormControl<OtpFormType>;

export const CustomOtpInput: Component = ({
  countdown,
  errors,
  hasOtpRetryAttempts,
  isOtpCodeInvalid,
  onOtpCodeChange,
  onResend,
  otpCode,
}) => {
  return (
    <div className="mx-auto flex w-full max-w-[26.3rem] flex-col gap-[1.4rem]">
      <OtpFormControl
        className="mb-0"
        errors={errors ?? {}}
        inputClassName="gap-[1.4rem] text-center"
        inputName="otp"
        isRequired
        showErrors
      >
        <OtpInput
          autoFocusFirstInput
          isInvalid={isOtpCodeInvalid ?? false}
          onChange={onOtpCodeChange}
          value={otpCode}
        />
      </OtpFormControl>
      {countdown === 0
        ? (
            <form className="mx-auto" onSubmit={onResend}>
              <span
                className="text-sm text-blue-700"
                onClick={onResend}
                onKeyDown={e => e.preventDefault()}
                role="button"
                tabIndex={0}
              >
                Resend OTP
              </span>
            </form>
          )
        : hasOtpRetryAttempts
          ? (
              <span className="block text-center text-sm">
                Please wait for
                {' '}
                <span className="font-semibold text-red-500">{countdown}</span>
                {' '}
                secs to resend.
              </span>
            )
          : (
              <></>
            )}
    </div>
  );
};
